module.exports = __webpack_public_path__ + "img/shiyanshenq.a554d6e5.png";